module.exports = __webpack_public_path__ + "img/reference58.a9e17568.jpg";